import {
  SET_MY_APPLICATIONS,
  SET_PENDING_APPLICATIONS,
  SET_APPLICATIONS_LOADING,
  APPLICATIONS_LOADED,
  SET_LANDLORD_REQUESTS,
  SET_LANDLORD_REQUESTS_LOADING,
  SET_PENDING_SKOR_PROTECT_ACTIONS,
} from "../types";

export default (state, action) => {
  switch (action.type) {
    case SET_MY_APPLICATIONS:
      return { ...state, myApplications: action.payload };
    case SET_PENDING_APPLICATIONS:
      return { ...state, pendingApplications: action.payload };
    case SET_APPLICATIONS_LOADING:
      return { ...state, loading: action.payload };
    case APPLICATIONS_LOADED:
      return { ...state, loaded: true };
    case SET_LANDLORD_REQUESTS:
      return { ...state, landlordRequests: action.payload };
    case SET_LANDLORD_REQUESTS_LOADING:
      return { ...state, landlordRequestsLoading: action.payload };
    case SET_PENDING_SKOR_PROTECT_ACTIONS:
      return { ...state, pendingSkorProtectActions: action.payload };
    default:
      return state;
  }
};
